"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textToCamelCase = exports.toLowerAndStripHttp = exports.toLowerOrEmpty = exports.empty = exports.errorCodeDict = void 0;
exports.errorCodeDict = {
    400: 'dårlig forespørgsel',
    401: 'ingen adgang',
    402: 'betaling påkrævet',
    403: 'forbudt',
    404: 'siden kan ikke findes',
    405: 'metoden er ikke tilladt',
    406: 'ikke accepteret',
    407: 'proxy adgang påkrævet',
    408: 'anmodning annulleret',
    409: 'konflikt',
    410: 'væk',
    411: 'længde påkrævet',
    412: 'forudsætning mislykkedes',
    413: 'last for stor',
    414: 'uri er for lang',
    415: 'medietypen er ikke understøttet',
    416: 'længe er ikke tilstrækkelig',
    417: 'forventning fejlet',
    418: 'jeg er en tekande',
    421: 'forkert forespørgsel',
    422: 'ubearbejdelig enhed',
    423: 'låst',
    424: 'fejl i afhængighed',
    425: 'for tidligt',
    426: 'opgradering nødvendig',
    428: 'forudsætning nødvendig',
    429: 'for mange forespørgsler',
    431: 'forespørgselses header er for stor',
    451: 'utilgængelig på grund af juridiske årsager',
    500: 'intern serverfejl',
    501: 'ingen gateway',
    502: 'dårlig gateway',
    503: 'server ikke tilgængelig',
    504: 'gateway timeout',
    505: 'http version er ikke understøttet',
    506: 'variant forhandler også',
    507: 'ikke tilstrækkelig data',
    508: 'sløjfe vujndet',
    510: 'ikke udvidet',
    511: 'netværksgodkendelse påkrævet',
};
exports.empty = 'ingen værdi';
const toLowerOrEmpty = (input) => (input ? input.toLowerCase() : exports.empty);
exports.toLowerOrEmpty = toLowerOrEmpty;
const toLowerAndStripHttp = (url) => {
    if (typeof url == 'undefined') {
        return exports.empty;
    }
    if (url.startsWith('https://')) {
        const https = 'https://';
        return url.slice(https.length).toLowerCase();
    }
    if (url.startsWith('http://')) {
        const http = 'http://';
        return url.slice(http.length).toLowerCase();
    }
    return url.toLowerCase();
};
exports.toLowerAndStripHttp = toLowerAndStripHttp;
const textToCamelCase = (inputString) => inputString
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => index === 0 ? match.toLowerCase() : match.toUpperCase())
    .replace(/\s+/g, '');
exports.textToCamelCase = textToCamelCase;
